
;( function( window ) {
  var searchUsed = false;
  $('.vacancies__region-select').on('change', function() {
    var form = $('.search-form');
    sendAjaxForm(undefined, form.attr('action'));
  });

  var hideHeaderArticles = function() {
    $('.blogs-controller-show .hero-image--blogs .hero-image__container').hide();
    $('.blogs-controller-show .hero-image--blogs .blog__latest-articles-background').hide();
    $('.blogs-controller-show .hero-image--blogs-articles').slideDown();
  };

  var showDefaultHero = function() {
    $('.blog--default-hero').show();
  }

  var handlePaginationLinks = function() {
    $('[data-behavior=pagination-link]').existsEach(function ($trigger) {
      $trigger.on('click', function(event) {
        var form = $('.search-form');
        var datastring = form.serialize();
        datastring = datastring + '&page=' + $trigger.data('page');
        if ($('.year-search__form').hasClass('year-search--open')) {
          $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: datastring,
            success: function(data) {
              var container = $('.search-result-container');
              container.html(data);
              picturefill();
              handlePaginationLinks();
              scrollToSearchBar();
            }
          });
        } else {
          sendAjaxForm($trigger.data('page'));
        }
        return false;
      });
    });
  };

  var scrollToSearchBar = function() {
    $('html, body').animate({
      scrollTop: $(".year-search__form").offset().top
    }, 500);
  };

  var sendAjaxForm = function(page, search_path) {
    var form = $('.search-form');
    var datastring = form.serialize();
    if (page !== undefined) {
      datastring = datastring + '&page=' + page
    }
    if (search_path == undefined) {
      search_path = $('#filter-items>li>a.active').attr('href')
    }

    $.ajax({
      type: "POST",
      url: search_path,
      data: datastring,
      success: function(data) {
        var container = $('.search-result-container');
        container.html(data);
        picturefill();
        handlePaginationLinks();
        hideHeaderArticles();
        showDefaultHero();
        scrollToSearchBar();
      }
    });
  };

  handlePaginationLinks();

  $('[data-behavior=filter-year]').existsEach(function ($trigger) {
    $trigger.on('click', function(event) {
      $('#filter-items>li>a.active').removeClass('active');
      $(this).addClass('active');
      sendAjaxForm();
      return false;
    });
  });

  $('[data-behavior=search]').existsEach(function ($trigger) {
    $trigger.on('ajax:success', function(event) {
      const data = event.detail[2].responseText;
      searchUsed = true;
      var container = $('.search-result-container');
      container.html(data);
      picturefill();
      handlePaginationLinks();
      hideHeaderArticles();
      showDefaultHero();
      scrollToSearchBar();
    });
  });

  $('[data-behavior=filter-checkbox]').existsEach(function($trigger) {
    $trigger.on('click', function(event) {
      var form = $trigger.closest('form');
      if ($('.year-search__form').hasClass('year-search--open')) {
        Rails.fire(form[0], 'submit');
        handlePaginationLinks();
        scrollToSearchBar();
      } else {
        sendAjaxForm();
      }
    });
  });

  // http://stackoverflow.com/a/11381730/989439
  function mobilecheck() {
    isMobile.any
  }

  // http://www.jonathantneal.com/blog/polyfills-and-prototypes/
  !String.prototype.trim && (String.prototype.trim = function() {
    return this.replace(/^\s+|\s+$/g, '');
  });

  function UISearch( el, options ) {
    var defaultSettings = {
      parentContainer: '.year-search__form'
    };
    this.settings = Object.assign(defaultSettings, options);

    this.el = el;
    this.parent = $(this.settings.parentContainer);
    this.inputEl = el.querySelector( 'form input.year-search__input' );
    this.closeBtn = el.querySelector('.year-search__close-icon')

    this._initEvents();
  }

  UISearch.prototype = {
    _initEvents : function() {
      var self = this,
        initSearchFn = function( ev ) {
          ev.stopPropagation();
          // trim its value
          self.inputEl.value = self.inputEl.value.trim();

          if( !$('self.el').hasClass('sb-search-open') ) { // open it
            if (!$('.year-search__form').hasClass('year-search--open')) {
              self.open();
            }
          }
          else if( $(self.el).hasClass('sb-search-open' ) && /^\s*$/.test( self.inputEl.value ) ) { // close it
            self.close();
          }
        }

      if (mobilecheck()) {
        this.el.addEventListener( 'touchstart', initSearchFn );
        this.inputEl.addEventListener( 'touchstart', function( ev ) { ev.stopPropagation(); } );  
      } else {
        this.el.addEventListener( 'click', initSearchFn );
        this.inputEl.addEventListener( 'click', function( ev ) { ev.stopPropagation(); });      
      }
    },
    open : function() {
      var self = this;
      $(this.el).addClass( 'sb-search-open' );
      $(this.parent).addClass('year-search--open');
      $(this.closeBtn).show();
      // focus the input)
      if( !mobilecheck() ) {
        this.inputEl.focus();
      }

      // close the search input if X is clicked
      var bodyFn = function( ev ) {
        self.close();
        $(this.closeBtn).hide();
        ev.stopPropagation();
        this.removeEventListener( 'click', bodyFn );
        this.removeEventListener( 'touchstart', bodyFn );
        return false;
      };
      if (mobilecheck()) {
        this.closeBtn.addEventListener('touchstart', bodyFn);
      } else {
        this.closeBtn.addEventListener('click', bodyFn);  
      }
    },
    close : function() {
      this.inputEl.blur();
      $(this.closeBtn).hide();
      $(this.parent).removeClass('year-search--open');
      $(this.el).removeClass( 'sb-search-open' );
      if (searchUsed) {
        sendAjaxForm();
      }
    }
  };

  // add to global namespace
  window.UISearch = UISearch;

} )( window );